export default __webpack_public_path__ + "static/media/changedIcon.8693a3b8.svg";